<template>
  <div class="questionbody flexwrap centercenter">
    <div id="thequestion">
      {{question}}
    </div>


    <div id="choices">
      <div v-for="(answer, index) in answers" :key="index">
        <div class="proposition flexwrap centercenter paddingRound SmallRoundAngles mediumShadow lightplainTheme"
             :class="[answered ? '': 'clickable', {goodAnswer: getColor(index) === 'green', badAnswer: getColor(index) === 'red'}]"
             @click="selectAnswer(index)">
          {{answer}}
        </div>
      </div>
    </div>
    <div style="display: grid; grid-gap: 1vw; grid-template-columns: auto auto;
      ">
      <standard-button class="flexwrap centercenter" :color-class="'red'" :href="'https://www.netflix.com/watch/' + currentEpisodeData.netflix_id + '?t=' + seconds">
        <div id="watchCardNetflix" class="flexwrap centercenter">
          <img id="watchCardNetflixImg" src="../assets/netflix.png" alt=""/>
        </div>
        <div>Watch again</div>
      </standard-button>
      <standard-button @click="sendAnswer()" :color-class="'blue'" v-show="answered">
        Next
      </standard-button>
    </div>


  </div>

</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: "question",
  components: {StandardButton: () => import(/* webpackPrefetch: true */ '@/components/standardButton.vue')},
  props: {
    question: String,
    answer: String,
    number: Number,
    otheranswers: String,
    time: String
  },

  created() {
    this.answers = this.otheranswers.split(';');
    this.randomInsert();
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
    ...mapGetters('show', [
      'currentEpisodeData',
    ]),
    seconds: function(){
      var a = this.time.split(':');
      return(+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
    }
  },

  methods: {
    randomInsert: function() {
      this.correctAnswerIndex = Math.trunc((Math.random() * this.answers.length+1))
      this.answers.splice(this.correctAnswerIndex,0, this.answer)
    },

    selectAnswer(index) {
      if(!this.answered) {
        this.answerSelected = index;
        this.answered = true;
      }
    },

    sendAnswer() {
      if(this.answerSelected !== -1) {
        let answer = 'wrong';
        if (this.answerSelected === this.correctAnswerIndex) {
          answer = 'correct'
        }
        this.$emit('sendAnswer', answer)
      }
    },

    getColor(index) {
      if(this.answerSelected !== -1) {
        if(index === this.correctAnswerIndex) {
          return 'green'
        }
        else {
          if(index === this.answerSelected)
          return 'red'
        }
      }
      else {
        return 'none'
      }
    }
  },

  data() {
    return {
      answers: [],
      correctAnswerIndex : -1,
      answerSelected: -1,
      answered: false
    }
  }
}
</script>

<style scoped>
  .questionbody {
    padding: 1vw;
    display: grid;
    grid-gap: 1vw;
    grid-template-rows: 1fr auto 1fr;
    height: calc(100% - 2vw);
  }

  #thequestion {
    align-self: center;
    font-size: 150%;
    font-weight: bold;
    text-align: center;
    align-content: flex-end;
    align-items: flex-end;
  }

  #watchCardNetflix{
    height: 1.5vw;
    width: 1.5vw;
    margin-right: 0.5vw;
    background-color: black;
    border-radius: 1.5vw;
  }
  #watchCardNetflixImg{
    height: 0.9vw
  }


  #choices {
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto auto auto auto;
    grid-gap: 1vw;
    padding-left: 1vw;
    padding-right: 1vw;
    width: calc(100% - 2vw);
    justify-content: center;
  }

  .proposition {
    position: relative;
    font-size: 120%;
    font-weight: bold;
    width: 20vw;
    min-height: 2.5em;
    height: fit-content;
    text-align: center;
  }

  .goodAnswer {
    background-color: #50fd86;
    color: var(--standardColor);
  }

  .badAnswer {
    background-color: #d44337;
    color: var(--goalBackgroundColor3);
  }

  @media screen and (max-device-width: 767px) {

    #choices {
      grid-gap: 1.5vw;
      padding-left: 1vw;
      padding-right: 1vw;
      width: calc(100% - 2vw);
    }
    .proposition {
      min-width: 70vw;
      min-height: 2.5em;
      height: fit-content;
    }

    #watchcard--start{
      grid-column: 1/2;
      grid-row: 3/4;
    }
    #watchCardNetflix{
      height: 6vw;
      width: 6vw;
      margin-right: 2vw;
      border-radius: 6vw;
    }
    #watchCardNetflixImg{
      height: 3.5vw
    }

  }
</style>